<template>
    <section
        id="hero"
        class="bg-info"
    >
        <b-container
            class="transition py-4 py-lg-5"
            :style="{ backgroundImage: `url(${require('@/contents/images/' + story.image)}` }"
        >
            <navbar class="mb-lg-5 mb-xl-10" />

            <b-row align-h="between">
                <b-col
                    sm="6"
                    class="my-5 mb-lg-0"
                >
                    <h1 class="text-white">
                        {{ $t(`${$route.name}.hero.title`) }}
                    </h1>
                </b-col>

                <b-col
                    sm="4"
                    lg="3"
                    class="col-8 mt-sm-5 mt-lg-0 mb-xl-3 quote"
                >
                    <transition
                        name="fade"
                        mode="out-in"
                    >
                        <story-link
                            :key="story.id"
                            :story="story"
                            title-class="h4 text-white"
                            quote-class="small text-primary"
                        />
                    </transition>
                </b-col>
            </b-row>
        </b-container>
    </section>
</template>

<script>
import stories from '@/contents/stories.json';
import Navbar from '@/components/common/Navbar';
import StoryLink from '@/components/common/StoryLink';

export default {
    name: 'Hero',
    components: { Navbar, StoryLink },
    data() {
        return {
            stories: null,
            story: null,
        };
    },
    watch: {
        $route: {
            handler: function(route) {
                const type = route.name === 'homeCancer' ? 'cancer' : 'general';

                // Only show stories that have image and correct type.
                this.stories = stories.filter(story => !!story.image && story.type === type);
            },
            immediate: true,
        },
    },
    created() {
        this.story = this.stories[0];

        setInterval(this.nextStory, 5000);
    },
    methods: {
        nextStory() {
            const currentIndex = this.stories.indexOf(this.story);

            if (currentIndex === this.stories.length - 1) {
                return this.story = this.stories[0];
            }

            this.story = this.stories[currentIndex + 1];
        },
    },
};
</script>

<style lang="scss" scoped>
#hero {
    @include media-breakpoint-up(xl) {
        .quote {
            min-height: 14rem;
        }
    }
}

.container:first-child {
    background-repeat: no-repeat;
    background-position: 75% 20%;

    @include media-breakpoint-down(md) {
        background-size: 70%;
    }

    @include media-breakpoint-down(xs) {
        height: 75vh;
        background-position: 35vw 130%;
        background-size: 100%;
    }
}
</style>
